(function () {
  const root = document.querySelector("[data-slides]");
  if (!root) return;
  const imgs = Array.from(root.querySelectorAll(".slides__img"));
  const cap = root.querySelector("[data-slide-cap]");
  const dotsWrap = root.querySelector("[data-slide-dots]");
  const captions = ["Live map", "Aircraft and operators", "Pick a bird. Follow it.", "Full operations view"];
  let i = 0;
  let paused = false;
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  imgs.forEach((_, n) => {
    const b = document.createElement("button");
    b.type = "button";
    b.className = "slides__dot" + (n === 0 ? " is-active" : "");
    b.setAttribute("aria-label", "Show " + captions[n]);
    b.addEventListener("click", () => go(n));
    dotsWrap.appendChild(b);
  });

  function go(n) {
    imgs[i].classList.remove("is-active");
    dotsWrap.children[i]?.classList.remove("is-active");
    i = (n + imgs.length) % imgs.length;
    imgs[i].classList.add("is-active");
    dotsWrap.children[i]?.classList.add("is-active");
    if (cap) cap.textContent = captions[i];
  }

  root.querySelector("[data-slide-prev]")?.addEventListener("click", () => go(i - 1));
  root.querySelector("[data-slide-next]")?.addEventListener("click", () => go(i + 1));
  root.addEventListener("mouseenter", () => (paused = true));
  root.addEventListener("mouseleave", () => (paused = false));

  if (!reduced) {
    setInterval(() => {
      if (!paused) go(i + 1);
    }, 5200);
  }
})();
